import React, {forwardRef, useState} from "react";

import EventNotes from "../EventNotes";
import Header from "../Header";
import ConfirmButton from "../ConfirmButton";
import ChangeQuarterAndTime from "../ChangeQuarterAndTime";
import Submit from "../HandleSubmit";

const handleSubmit = (options) => {
    const {matchId, matchData, setMatchData, eventDetailsToEdit: event} =  options
    const eventQuarter = event.quarterSelected
    let quarter = '';
    if(eventQuarter) {
        switch (eventQuarter) {
            case 'Q1':
                quarter = 1;
                break;
            case 'Q2':
                quarter = 2;
                break;
            case 'Q3':
                quarter = 3;
                break;
            case 'Q4':
                quarter = 4;
                break;
        }
    }

    const update = {
        matchPosts: matchData.matchPosts.map(post => {
            if(event.id === post.id) {
                return {
                    ...post,
                    minute: Math.ceil(event.timestamp/60),
                    additionalData: event.eventNotes,
                    quarter,
                    isChanged: true
                }
            }
            return post;
        })
    }

    Submit(matchId, matchData, update, setMatchData);

}

const EditEventNotes = forwardRef(
  (
    {
      setIsEditModalOpen,
      eventDetailsToEdit,
      setEventDetailsToEdit,
      setEventsToShow,
      isEditing,
      setIsEditing,
      matchData,
      matchId,
      setMatchData,
    },
    ref
  ) => {
    const [confirmButton, setConfirmButton] = useState(false);
    const quarterEventsIds = [1, 2, 3, 4, 5, 6, 7, 8];
    return (
      <div
        ref={ref}
        style={{
          backgroundColor: "#E5E5E5",
        }}
      >
        <Header
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
          setModalOpen={setIsEditModalOpen}
          isEditing={isEditing}
          setEventsToShow={setEventsToShow}
          matchData={matchData}
          matchId={matchId}
          setMatchData={setMatchData}
        />
          {!quarterEventsIds.includes(eventDetailsToEdit?.postType) &&
              <ChangeQuarterAndTime
                  eventDetails={eventDetailsToEdit}
                  setEventDetails={setEventDetailsToEdit}
                  matchId={matchId}
                  setMatchData={setMatchData}
                  matchData={matchData}
                  setConfirmButton={setConfirmButton}
                  setEventsToShow={setEventsToShow}
              />
          }


        <EventNotes
          textAreaValue={eventDetailsToEdit?.eventNotes}
          showConfirmCancelButtons={!!eventDetailsToEdit?.eventNotes?.length}
          confirmButtonAction={() => {}}
          cancelButtonAction={() => {
            setEventDetailsToEdit((data) => ({
              ...data,
              eventNotes: "",
            }));
          }}
          onChange={(e) => {
            setEventDetailsToEdit((data) => ({
              ...data,
              eventNotes: e.target.value,
            }));
          }}
        />

          <ConfirmButton
              action={() => {
                  setEventsToShow((data) => {
                      handleSubmit({matchId, matchData, setMatchData, eventDetailsToEdit})
                      return [
                          ...data?.map((item) => {
                              if (item?.id === eventDetailsToEdit?.id) {
                                  return eventDetailsToEdit;
                              } else return item;
                          }),
                      ];
                  });
                  setIsEditing(false);
                  setIsEditModalOpen(false);
              }}
          />

      </div>
    );
  }
);

export default EditEventNotes;
